const yandexMapsApikey = process.env.VUE_APP_YANDEX_MAPS_APIKEY;

let yandexMapsSrc = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
if (!!yandexMapsApikey) {
  yandexMapsSrc += `&apikey=${yandexMapsApikey}`;
}

export default Object.freeze({
  YANDEX_MAP_SCRIPT_SRC: yandexMapsSrc,

  // Минимальная сумма предоплаты
  MIN_PREPAYMENT_AMOUNT: 500,

  // Сумма акции по умолчанию
  DEFAULT_FLYER_AMOUNT: 200,

  // Услуги без собственного списка адресов
  SERVICES_WITHOUT_OWN_ADDRESS_LIST: ['OrderToDowntime'],

  // Услуги со списком адресов, являющимся подмножеством адресов заявки
  SERVICES_WITH_ADDRESS_LIST_DEPENDANT_ON_ORDER_ADDRESS_LIST: ['OrderToTrucking', 'OrderToMover', 'OrderToFurniture', 'OrderToGarbage'],

  // Услуги со своим отдельным значением расстояния
  SERVICES_WITH_OWN_DISTANCE: ['OrderToTrucking']
})
